import React from "react";
import Image from "../Tags/Image";

export default function NoInfo({
  heading = "No information found",
  description = "We weren’t able to find any information here.",
  imgWidth = "w-9/12",
}) {
  return (
    <div className="py-6">
      <Image className="no-invert" src="/images/ext/company-no-found.svg" className={`mx-auto max-w-[300px] ${imgWidth}`} />
      <div className="flex w-full justify-center items-center mt-6">
        <span className="text-base text-gray-900">{heading}</span>
      </div>
      <div className="flex w-full justify-center items-center mt-2">
        <span className="text-sm text-gray-600">{description}</span>
      </div>
    </div>
  );
}
